import * as React from "react";

import { useEphemeralWorkspaceState } from "@/shared/components/visualization/WorkspaceCtx";

import { PositionPreset, presets } from "./presets";

export function useWorkspacePositionPresets() {
  const state = useEphemeralWorkspaceState();
  const prefilledPresets = React.useMemo(
    // TODO(dave): we can pull this out into a hook, and use it to handle topic drag-and-drop.
    // Any dropped topic that matches a preset would be loaded.
    function findValidPresets() {
      const prefilled: PositionPreset[] = [];
      const idToFile = Object.fromEntries(
        state.files.map((f) => [f.file_id, f]),
      );
      for (const topic of state.topics) {
        const file = idToFile[topic.association.association_id];
        if (topic.topic_name === "vehicle_global_position") {
          prefilled.push(
            specifyPreset({
              preset: presets.lat_lon_alt,
              title:
                state.files.length > 1
                  ? `vehicle_global_position (PX4) (${file.name})`
                  : "vehicle_global_position (PX4)",
              fileId: file.file_id,
              rightPath: "vehicle_global_position.lat",
              forwardPath: "vehicle_global_position.lon",
              upPath: "vehicle_global_position.alt_ellipsoid",
            }),
          );
        }
        if (topic.topic_name === "vehicle_local_position") {
          prefilled.push(
            specifyPreset({
              preset: presets.north_east_down,
              title:
                state.files.length > 1
                  ? `vehicle_local_position (PX4) (${file.name})`
                  : "vehicle_local_position (PX4)",
              fileId: file.file_id,
              forwardPath: "vehicle_local_position.x",
              rightPath: "vehicle_local_position.y",
              upPath: "vehicle_local_position.z",
            }),
          );
        }
      }
      return prefilled;
    },
    [state.files, state.topics],
  );
  return prefilledPresets;
}

/**
 * Constructs a new preset with a specific file, message path, and display messages.
 */
function specifyPreset({
  preset,
  title,
  fileId,
  forwardPath,
  rightPath,
  upPath,
}: {
  preset: PositionPreset;
  title: string;
  fileId: string;
  forwardPath: string;
  rightPath: string;
  upPath: string;
}): PositionPreset {
  return {
    ...preset,
    name: {
      // No hint needed on a fully-specified preset.
      formatHint: "",
      // Move the base preset's title into the subtitle.
      subtitle: `${preset.name.title} (${preset.name.subtitle})`,
      // Replace the preset title with the customized preset's title.
      title,
    },
    bindings: {
      forward: {
        fileId,
        path: forwardPath,
      },
      right: {
        fileId,
        path: rightPath,
      },
      up: {
        fileId,
        path: upPath,
      },
    },
  };
}
